import React from 'react';
import styled from 'App/styled';
import { CategoryTreeProps } from '../types';
import Bar from './bar';


const CategoryWrapper = styled.ul`
  &.scroll {
    overflow-x: hidden;
    overflow-y: overlay;
  }
  overflow: hidden;
  // max-height: inherit;
`;

const CategoryTree = (props: CategoryTreeProps) => {
  const { selectedFilterData, list, navigateFilters, handleFilterChange } = props;
  const childrenLength = list?.length || 0;
  const scrollClass = childrenLength > 1 ? 'scroll' : '';
  return (
    <CategoryWrapper key={`ul_cat_${Math.random()}`} className={scrollClass}>
      {list?.map((item: any, index: number) => (
        <Bar
          selectedFilterData={selectedFilterData}
          filterValue={item}
          navigateFilters={navigateFilters}
          key={`fac_cat_${index}`}
          handleFilterChange={handleFilterChange}
        />
      ))}
    </CategoryWrapper>
  );
};

export default CategoryTree;
